import React, { PureComponent } from 'react';
import { PropTypes as T } from 'prop-types';
import { Row, Col, Input, Button, Form, FormGroup } from 'reactstrap';

import { appUrl } from 'utils/wrappers';
import { showError } from 'utils/messages';

import BaseModel from 'app/models/base';

import LoaderView from 'app/views/loader_view';
import BackboneView from 'app/components/backbone_view';

export const USPSZone = BaseModel.extend({
  url: appUrl('usps_zones'),
});

export default class USPSZoneLookupPage extends PureComponent {
  static defaultProps = {
    model: new USPSZone({}),
  }

  static propTypes = {
    model: T.instanceOf(USPSZone),
  }

  constructor(props) {
    super(props);
    this.state = {
      fromZip: '',
      toZip: '',
      uspsZone: '',
    };
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = async e => {
    e.preventDefault();
    this.setState({ uspsZone: '' });
    try {
      const uspsZone = (await this.fetchZone(this.state.fromZip, this.state.toZip)).get('usps_zone');
      if (uspsZone) {
        this.setState({ uspsZone });
      } else {
        showError('No Results');
      }
    } catch (err) {
      showError('Invalid Zones');
    }
  }

  fetchZone(fromZip, toZip) {
    return this.props.model.fetchAsPromise({
      data: { from: fromZip, to: toZip },
    });
  }

  render() {
    return (
      <section className="container-sm my-6">
        <Row>
          <Col sm="10">
            <h1>USPS Zone Lookup</h1>
            <p>Determining USPS rates means you have to know your postal zones. This zip code lookup tool can  determine the zone of your destination{'\''}s address.</p>
          </Col>
        </Row>

        <Row className="my-6">
          <Col sm="6">
            <Form onSubmit={this.handleSubmit}>
              <FormGroup>
                <h3>Origin Zip</h3>
                <Input name="fromZip" value={this.state.fromZip} onChange={this.handleChange} />
              </FormGroup>
              <FormGroup>
                <h3>Destination Zip</h3>
                <Input name="toZip" value={this.state.toZip} onChange={this.handleChange} />
              </FormGroup>
              <FormGroup>
                <Row>
                  <Col sm="6">
                    <Button color="secondary" block>Lookup</Button>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </Col>

          <Col sm="6" className="text-center">
            { this.state.uspsZone ? (
              <div>
                <h3>Zone</h3>
                <h1 className="bold display-1">{this.state.uspsZone}</h1>
              </div>
            ) : null }
            <BackboneView View={LoaderView} viewProps={() => ({ model: this.props.model })} className="loader" />
          </Col>
        </Row>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/pages/usps_zone_lookup/index.jsx